import { getDashboardSummary as rpcGetDashboardSummary } from "./postgre/dashboardApi";

export const getDashboardSummary = async () => rpcGetDashboardSummary();
